import { AfterViewChecked, Component, ElementRef, HostListener, Renderer2, ViewChild } from '@angular/core';
import { Store } from '@ngrx/store';
import { environment } from 'src/environments/environment';
import { userLoaded } from '../store/reducer/user.reducer';
import { ToastService } from '../shared/services/toast.service';
import { MagicSearchService } from '../magic-search/services/magic-search.service';

@Component({
    standalone: false,
    selector: 'app-layout',
    templateUrl: './layout.component.html',
    styleUrls: ['./layout.component.scss']
})
export class LayoutComponent implements AfterViewChecked {
    toast$ = this.toastService.toast$;
    userLoaded$ = this.store.select(userLoaded);

    @ViewChild('environmentHeader') environmentHeader: ElementRef;

    private environmentHeaderLoaded = false;

    constructor(
        private store: Store,
        private renderer: Renderer2,
        private toastService: ToastService,
        private magicSearch: MagicSearchService
    ) {}

    @HostListener('document:keydown', ['$event'])
    onKeydown(event: KeyboardEvent): void {
        if ((event.ctrlKey || event.metaKey) && event.key.toLowerCase() === 'k') {
            event.preventDefault();
            this.magicSearch.open();
        }
    }

    ngAfterViewChecked(): void {
        this.setEnvironmentHeaderColor();
    }

    setEnvironmentHeaderColor(): void {
        if (!this.environmentHeaderLoaded && this.environmentHeader?.nativeElement) {
            this.renderer.setStyle(this.environmentHeader.nativeElement, 'background-color', environment.environmentHeaderColor);
            this.environmentHeaderLoaded = true;
        }
    }

    onToastClose(): void {
        this.toastService.hide();
    }

    getCurrentDate(): Date {
        return new Date();
    }
}
